module.exports = __webpack_public_path__ + "static/bi-slider3-b02f2260ac78100adf66dc830df2ac23.jpeg";